import { useNavigate } from "react-router";

export function About() {
	const navigate = useNavigate();

	return (
		<div className="relative h-dvh w-full" style={{ background: "#81818130" }}>
			<div className="absolute inset-0 pointer-events-none z-0">
				<img
					src="/images/Home2.png"
					alt=""
					style={{ opacity: 0.5, width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }}
				/>
			</div>

			<div className="absolute inset-0 z-10 p-[24px]">
				<div className="h-full max-w-[800px] mx-auto border border-white bg-black overflow-hidden flex flex-col">
					<div className="flex items-center gap-2 p-[24px] border-b border-white shrink-0 min-h-[72px] bg-[#1F1F1F] text-white">
						<button
							onClick={() => navigate("/")}
							className="group cursor-pointer hover:text-white transition-colors text-sm tracking-widest flex items-center gap-2"
						>
							<img src="/images/left-arrow.svg" alt="back" className="w-4 h-4" />
						</button>
						<span className="uppercase font-tomorrow-bold leading-[130%] tracking-[20%]">About</span>
					</div>

					<div className="flex-1 min-h-0 overflow-y-auto chat-scrollbar font-tomorrow-light text-[16px] leading-[130%] tracking-[20%] text-white/80 px-[60px] py-[24px]">
						<p>
							Eternal Human Chat is a web-based, multi-room chat environment where no one has a profile, no one is
							remembered, and nothing is archived. Each room appears with the first message, stays alive as long as
							people keep talking, and dies after 24 hours of silence.
						</p>
						<br />
						<p>
							Chat rooms are born when someone starts a conversation and disappear if there are 24 hours of silence. We
							do not store your chats for later use, we do not train systems on them, and we do not sell them to anyone.
							There are no accounts, no avatars, no followers, no analytics. Every time you enter, you receive a new
							random name. Users meet in chat spaces where no chat logs are stored and every room is temporary.
						</p>
						<br />
						<p>
							Communication exists only in the here-and-now of the moment and the text. We use a quiet moderation layer
							that blocks threats and obvious abuse before they appear on the screen, but does not score you, rate you,
							or turn behavior into a game. The project is about simple presence between strangers, not performance.
						</p>
						<br />
						<p>
							The work revives the spirit of early IRC-era chats as a humane intervention in today’s AI-saturated,
							corporate internet, offering a fragile space for sincere, ephemeral conversations between strangers around
							the globe.
						</p>
						<br />
						<p>
							A hyperreal mIRC that Kropotkin would like. Here, everyone has the right to be unknown and the right to
							vanish. Eternal Human Chat is a work by Georgian writer and artist Zura Jishkariani.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
